module.exports = __webpack_public_path__ + "static/media/main_m.f8111794.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/main_m.jpg
// module id = 420
// module chunks = 0